export const MODAL_OPEN = 'MODAL_OPEN';

export const openModal = (type, modalProps) => ({
  type: MODAL_OPEN,
  payload: {
    type,
    modalProps,
  },
});
